<template>
  <layouts-header></layouts-header>

  <breadcrumb :title="title" :text="text" :text1="text1" />
  <coach-settings-tabset></coach-settings-tabset>
  <div class="content court-bg">
    <div class="container">
      <settings-tabset></settings-tabset>
      <div class="row">
        <div class="col-sm-12">
          <div class="profile-detail-group">
            <div class="card">
              <form>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="appoint-head">
                      <h4>Change Email</h4>
                    </div>
                    <div class="input-space other-setting-form">
                      <label class="form-label"> Enter New Email Address</label>
                      <input
                        type="text"
                        class="form-control"
                        id="password"
                        placeholder="Enter New Email Address"
                      />
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="appoint-head">
                      <h4>Change Phone Number</h4>
                    </div>
                    <div class="input-space other-setting-form">
                      <label class="form-label">New Phone Number</label>
                      <input
                        type="text"
                        class="form-control"
                        id="phone"
                        placeholder="Enter New  Phone Number"
                      />
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="deactivate-account-blk">
                      <div class="deactivate-detail">
                        <h4>Deactivate Account</h4>
                        <p>Click delete button to deactivate the account</p>
                      </div>
                      <a
                        href="javascript:void(0)"
                        class="btn deactive-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#deactive"
                        ><i class="feather-zap-off"></i>Deactive Account</a
                      >
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="save-changes text-end">
              <a href="javascript:;" class="btn btn-primary reset-profile">Reset</a>
              <a
                href="javascript:;"
                class="btn btn-secondary save-profile"
                data-bs-toggle="modal"
                data-bs-target="#success-mail"
                >Save Change</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
  <profile-othersetting-modal></profile-othersetting-modal>
</template>
<script>
export default {
  data() {
    return {
      title: "Other Settings",
      text: "Home",
      text1: "Other Settings",
    };
  },
};
</script>
